// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// constants imports
import { MessageInterval } from '../../../../_constants/messages-intervals';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { WorkOrderProposalRawDto } from '../../../_models/work-order-proposal-raw-dto';

@Component({
    selector: 'app-edit-vendor-for-proposal',
    templateUrl: './edit-vendor-for-proposal.component.html',
    styleUrls: ['./edit-vendor-for-proposal.component.scss']
})
export class EditVendorForProposalComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('editVendorForProposalPopup', { static: false }) editVendorForProposalPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() workOrderId: number;
    @Input() customerId: string;
    @Input() workOrderProposalId: number;
    @Input() estimatedAmount: number;

    @Output() onClose = new EventEmitter<void>();

    visible = false;
    showProposalQuoteManager = false;

    minAmount = 0;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.editVendorForProposalPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeEditor();
    }

    onUploadClick(): void {
        this.showProposalQuoteManager = true;
    }

    onQuoteManagerClose(): void {
        this.showProposalQuoteManager = false;
    }

    onSaveClick(): void {
        const baseParam: WorkOrderProposalRawDto = new WorkOrderProposalRawDto();
        baseParam.communityId = this.communityId;
        baseParam.workOrderId = this.workOrderId;
        baseParam.workOrderProposalId = this.workOrderProposalId;
        baseParam.estimatedAmount = this.estimatedAmount;

        this.workOrderHelperService.showLoading();
        this.workOrderService.updateWorkOrderProposal(baseParam).subscribe(
            (result: any) => {
                notify('Vendor For Proposal updated successfully.', 'Success', MessageInterval.successMsgInterval);
                this.closeEditor();
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    private closeEditor(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
